import { FaPlus, FaUsers, FaFileContract, FaCogs, FaSignOutAlt, FaUserEdit, FaTimes, FaFileInvoiceDollar } from 'react-icons/fa';
import { supabase } from './supabaseClient';
import { useNavigate, useLocation } from 'react-router-dom';
import logow from './logow.png';
import './tailwind.css';

// SidebarMenu: menu laterale per il ruolo Broker
export default function SidebarMenu({ nome, cognome, isOpen, closeSidebar, userRole }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    window.location.href = '/';
  };

  /**
   * Restituisce le classi Tailwind per i link della sidebar.
   * Evidenzia il link se la path corrente corrisponde a quella del link.
   */
  const getNavLinkClasses = (path) => {
    const baseClasses =
      'flex items-center p-4 text-gray-200 hover:bg-miobluhover hover:text-white transition-colors duration-200 cursor-pointer text-base rounded-lg';
    const activeClasses = 'bg-miobluhover text-red-500 font-semibold shadow-inner';

    let isActive = location.pathname === path;

    // Gestione speciale per la voce "Gestisci Polizze" che è la root dashboard/broker
    if (
      path === '/dashboard/broker' &&
      (location.pathname === '/dashboard/broker' || location.pathname.startsWith('/dashboard/broker/polizze'))
    ) {
      isActive = true;
    }

    return `${baseClasses} ${isActive ? activeClasses : ''}`;
  };

  return (
    <aside
      className={`fixed top-0 left-0 h-full bg-mioblu text-white shadow-lg transform transition-transform duration-300 ease-in-out z-50 ${
        isOpen ? 'translate-x-0 flex flex-col' : '-translate-x-full hidden'
      } w-full md:w-64 md:relative md:translate-x-0 md:flex md:flex-col md:flex-shrink-0 md:h-auto md:shadow-none md:z-auto`}
    >
      {/* HEADER */}
      <div className="p-6 pb-4 border-b border-miobluhover text-center relative">
        <img src={logow} alt="Europassistance Logo" className="h-12 mx-auto mb-3" />
        <small className="text-gray-200 block text-sm">BUONGIORNO</small>
        <div className="text-xl font-semibold mt-1">
          {nome} {cognome}
        </div>
        {/* Pulsante di chiusura (solo mobile) */}
        <button
          onClick={closeSidebar}
          className="absolute top-4 right-4 text-white text-2xl bg-transparent border-none cursor-pointer p-1 md:hidden"
        >
          <FaTimes />
        </button>
      </div>

      {/* MENU */}
      <ul className="list-none p-0 my-4 flex-1 overflow-y-auto" onClick={closeSidebar}>
        {/* GESTISCI POLIZZE */}
        <li className={getNavLinkClasses('/dashboard/broker')} onClick={() => navigate('/dashboard/broker') }>
          <FaFileContract className="mr-3 text-lg" /> <span>Gestisci Adesioni</span>
        </li>

        {/* Annulla Adesione */}  
<li
  className={getNavLinkClasses('/dashboard/broker/annulla-polizza')} 
  onClick={() => { navigate('/dashboard/broker/annulla-polizza'); }} 
>
  <FaFileInvoiceDollar className="mr-3 text-lg" /> <span>Annulla Adesione</span>
</li>

        {/* CREA AGENZIA */}
        <li
          className={getNavLinkClasses('/dashboard/broker/crea-agenzia')}
          onClick={() => navigate('/dashboard/broker/crea-agenzia')}
        >
          <FaPlus className="mr-3 text-lg" /> <span>Crea Sede</span>
        </li>

        {/* GESTISCI AGENZIE */}
        <li
          className={getNavLinkClasses('/dashboard/broker/gestisci-agenzie')}
          onClick={() => navigate('/dashboard/broker/gestisci-agenzie')}
        >
          <FaUsers className="mr-3 text-lg" /> <span>Gestisci Sedi</span>
        </li>

        {/* CREA AGENTE */}
        <li
          className={getNavLinkClasses('/dashboard/broker/crea-agente')}
          onClick={() => navigate('/dashboard/broker/crea-agente')}
        >
          <FaPlus className="mr-3 text-lg" /> <span>Crea Account</span>
        </li>

        {/* GESTISCI AGENTI */}
        <li
          className={getNavLinkClasses('/dashboard/broker/gestisci-agenti')}
          onClick={() => navigate('/dashboard/broker/gestisci-agenti')}
        >
          <FaUsers className="mr-3 text-lg" /> <span>Gestisci Account</span>
        </li>

      </ul>

      {/* FOOTER */}
      <div className="p-4 flex flex-col space-y-3 border-t border-miobluhover">
        <button
          className={
            getNavLinkClasses('/dashboard/broker/profilo')
              .replace('text-gray-200', 'text-white')
              .replace('p-4', 'py-3 px-4')
          }
          onClick={() => navigate('/dashboard/broker/profilo')}
        >
          <FaUserEdit className="mr-3 text-lg" /> Aggiorna profilo
        </button>
        <button
          className="flex items-center justify-center w-full py-3 px-4 bg-miorosso text-white rounded-md transition-colors duration-200 hover:bg-miorossohover focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
          onClick={handleLogout}
        >
          <FaSignOutAlt className="mr-3 text-lg" /> Logout
        </button>
      </div>
    </aside>
  );
}
